import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useStore } from "@/stores/useStore.ts";
import { localStorageManager } from "@/services/localStorage.ts";
import { DashboardPage } from "@/pages";
import { LOCAL_STORAGE_BASE_KEYS } from "@/types/v2";

export const ShopLayoutPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { allowedShops } = useStore((s) => s);
  const { shopId } = useParams();
  const setCurrentShopId = useStore((s) => s.setCurrentShopId);
  const shop = useStore((s) => s.shop);

  useEffect(() => {
    const allowedShopIds = allowedShops.map((shop) => shop.id);
    if (shopId) {
      if (allowedShopIds.includes(shopId)) {
        setCurrentShopId(shopId);
        if (!location.pathname.includes(shopId)) {
          navigate(`/${shopId}`);
        }
        return;
      }
    }
    if (!shopId) {
      const lastShopId = localStorageManager.getItem(
        LOCAL_STORAGE_BASE_KEYS.SHOP_ID
      );
      if (
        lastShopId &&
        allowedShopIds.includes(lastShopId) &&
        shop?.id !== lastShopId
      ) {
        setCurrentShopId(lastShopId);
        if (!location.pathname.includes(lastShopId)) {
          navigate(`/${lastShopId}`);
        }
        return;
      }
    }
  }, [allowedShops, setCurrentShopId]);

  if (!shopId || allowedShops.length === 0) {
    return <DashboardPage />;
  }

  return <Outlet />;
};
